module.exports = __webpack_public_path__ + "img/批量同步.dbd085c1.svg";